// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-11QBb";
var _3 = "flights-fxCzn";
var _4 = "planeIcon-1UtiL";
var _5 = "flight-KXGeE";
var _6 = "flight_noMargin-2FM0z";
export { _1 as "__esModule", _2 as "wrapper", _3 as "flights", _4 as "planeIcon", _5 as "flight", _6 as "flight_noMargin" }
export default { "__esModule": _1, "wrapper": _2, "flights": _3, "planeIcon": _4, "flight": _5, "flight_noMargin": _6 }
